<template lang="pug">

  .playcards-component(v-if='cards')
    .playcards(v-if='visibleCards.length')
      .row
        div(v-for='card in visibleCards', :key='card.id', :class="containerClass")
          .playcard
            .playcard-image
            .playcard-number {{ $t('cards.card_number') }}
            .playcard-number-value {{ card.barcode }}
            .row(v-for="(value, key) in card.balance", :key="key")
              .playcard-property-title.col-5 {{ $t(`balance.${key}.label`) }}
              .playcard-property-value.col-7 {{ $t(`balance.${key}.value`, { value }) }}
            .py-3
              span.playcard-primary(v-if='card.is_primary') {{ $t('cards.primary_card') }}
              a.form-link(v-else='', href='#', @click.prevent='setAsPrimary(card.id)') {{ $t('cards.set_as_primary') }}
              br
              a.form-link.text-muted(href='#', @click.prevent='confirmArchive(card.id)') {{ $t('cards.archive') }}
            div
              router-link.btn.btn-default.btn-block(:to="{ name: 'playcards.reload', params: { barcode: card.barcode } }") {{ $t('cards.reload_playcard') }}
        div(:class="emptyContainerClass")
          .playcard
            slot
      .row(v-if="pages > 1")
        .offset-4.col-4
          .page-selectors
            template(v-for="p in (pages > page + 2 ? page + 2 : pages)")
              a.page-selector(href="#" @click.prevent="setPage(p)", :class="{ selected: page == p }") {{ p }}
            a.page-selector-more(v-if="page + 2 < pages", href="#" @click.prevent="setPage(page + 1)") >>
    template(v-else='')
      .no-playcards
        .no-playcard
        .no-playcard-balance Balance
        .no-playcard-balance-value $0
        router-link.btn.btn-default.btn-block(:to="{ name: 'playcards.buy' }") Purchase swipe card
      .no-playcards
        slot

    modal.playcard-archive-modal(v-if="showArchiveModal", @close="showArchiveModal = false")
      .v-modal-title Do you want to archive your Swipe Card?
      form(@submit.prevent="archive", @keydown="archiveForm.onKeydown($event)")
        .v-modal-message
        .v-modal-buttons
          .btn.btn-secondary(@click="showArchiveModal = false") {{ $t('cards.no') }}
          v-button.btn-primary(:loading="archiveForm.busy") {{ $t('cards.yes') }}

    form-success-modal(:form="archiveForm")
      template(slot="title") Success!
      template(slot="message") Your Swipe Card has been archived.
      template(slot="buttons")
        button.btn.btn-primary(@click="archiveForm.successful = false") {{ $t('add_playcard.my_play_cards') }}

</template>

<script>
import axios from 'axios';
import Form from 'vform'

const CARDS_PER_PAGE = 6;

export default {
  name: 'playcards',

  props: {
    containerClass: {
      type: String,
      default: 'col-12 col-lg-6 col-xl-4'
    },
    emptyContainerClass: {
      type: String,
      default: 'col-12 col-lg-6 col-xl-4'
    }
  },

  data: () => ({
    cards: null,
    pages: 0,
    page: 1,
    visibleCards: null,
    showArchiveModal: false,
    archiveCardId: null,
    archiveForm: new Form({})
  }),

  created() {
    this.$store.dispatch('authGuard', this);
    this.load();
  },

  methods: {
    load(retrieveBalance = false) {
      axios.get(`${window.addiesaas.url}/api/playcards/playcard?retrieve_balance=${retrieveBalance}`).then(function (response) {
        this.cards = response.data.playcards.map(c => c.data);
        this.pages = Math.floor((this.cards.length - 1) / CARDS_PER_PAGE) + 1;
        this.setVisibleCards();

        if (!retrieveBalance && this.cards.filter(c => c.is_balance_expired).length) {
          this.load(true);
        }
      }.bind(this));
    },

    setPage(page) {
      this.page = page;
      this.setVisibleCards();
    },

    setVisibleCards() {
      this.visibleCards = this.cards.slice((this.page - 1) * CARDS_PER_PAGE, this.page * CARDS_PER_PAGE);
    },

    setAsPrimary(card_id) {
      axios.post(`${window.addiesaas.url}/api/playcards/playcard/${card_id}/primary`).then(function () {
        this.load();
      }.bind(this));
    },

    confirmArchive(card_id) {
      this.archiveCardId = card_id;
      this.showArchiveModal = true;
    },

    async archive() {
      await this.archiveForm.post(`${window.addiesaas.url}/api/playcards/playcard/${this.archiveCardId}/archive`);
      this.showArchiveModal = false;
      this.load();
    }
  }
}
</script>
